import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import withPropsOnChange from 'recompose/withPropsOnChange';

import {
  getDepositsForDashboard,
  getProductSalesSum,
  getServiceSalesSum,
  getServicesCountTable,
  getTotalRefunds,
  getTotalSum,
} from '../selectors';
import Dashboard from './Dashboard';
import {
  getShopUserReports,
  getShopProductSaleReports,
  fetchShopServicesCount,
  fetchShopDiscountAmount,
  getShopDepositsReport,
} from '../actions';
import fetchData from '../hoc/fetchData';
import { getProductsTable } from '../products/selectors';
import {
  fetchSales,
} from '../products/actions';
import {
  fetchBrandItems,
} from '../../../products/brands/actions';
import { canUseGiftCards, getShopBrandId } from '../../../auth/selectors';

const mapStateToProps = state => ({
  shop: state.auth.shop,
  brandId: getShopBrandId(state),
  servicesRevenue: getServiceSalesSum(state),
  productRevenue: getProductSalesSum(state),
  totalRevenue: getTotalSum(state),
  products: getProductsTable(state),
  services: getServicesCountTable(state),
  deposits: getDepositsForDashboard(state),
  totalRefunds: getTotalRefunds(state),
  showGiftCards: canUseGiftCards(state),
});

const mapDispatchToProps = {
  getShopProductSaleReports,
  getShopUserReports,
  fetchSales,
  fetchShopServicesCount,
  fetchBrandItems,
  fetchShopDiscountAmount,
  getShopDepositsReport,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    getReport: props => (start, end) => Promise.all([
      props.getShopProductSaleReports(props.shop, start, end),
      props.getShopUserReports(props.shop, start, end),
      props.fetchSales(props.shop, start, end),
      props.fetchShopServicesCount(props.shop, start, end),
      props.fetchShopDiscountAmount(props.shop, start, end),
      props.getShopDepositsReport(props.shop, start, end, { notify: false }),
    ]),
  }),
  fetchData,
  // Magic usage of withPropsOnChange. Potentially it could pollute props with returned value from `dispatch`
  withPropsOnChange([], props => props.fetchBrandItems(props.brandId))
);

export default enhance(Dashboard);
